import RestDataSource from "./restdatasource";
import { Global_var } from "../global/global_var";
import {
  fetchLearnerEnquiryPending,
  fetchLearnerEnquiryError,
  fetchLearnerEnquirySuccess
} from "../action/learnerEnquiryAction";

export const GeneralEnquiryService = {
  PostEnquiry,
  getEnquiry,
  SendMail,
  getInTouchReportList
};     

function PostEnquiry(user, fn, fnError) {
  
  //console.log("user" + user);
  var url = Global_var.BASEURL + Global_var.URL_GENERALENQUIRY;

  return new RestDataSource(url, fnError).Store(user, res => {
    
    if (res != null) {
      if (res.headers["jtitoken"] != null) {
        localStorage.setItem("jti-token", res.headers.jtitoken);
      }
      fn(res.data);
    }
  });
}

function SendMail(user, fn, fnError) {
  
  //console.log("user" + user);
  var url = Global_var.BASEURL + Global_var.URL_ADMIN_SEND_EMAIL;

  return new RestDataSource(url, fnError).Store(user, res => {
    
    if (res != null) {
      if (res.headers["jtitoken"] != null) {
        localStorage.setItem("jti-token", res.headers.jtitoken);
      }
      fn(res.data);
    }
  });
}
function getEnquiry(datParam) {
  var url = Global_var.BASEURL + Global_var.URL_GENERALENQUIRY;
  return dispatch => {
    dispatch(fetchLearnerEnquiryPending());
    return new RestDataSource(url, err =>
      dispatch(fetchLearnerEnquiryError(err.message))
    ).GetOneByParam(datParam,res => {
      if (res != null) {
        if (res.headers["jtitoken"] != null) {
          localStorage.setItem("jti-token", res.headers.jtitoken);
        }
        dispatch(fetchLearnerEnquirySuccess(res.data.responseListObject));
      }
    });
  };
}
function getInTouchReportList(data, fn, fnError) {
  var url = Global_var.BASEURL + Global_var.URL_GETINTOUCH_REPORT_LIST;
  return new RestDataSource(url, fnError).GetOneByParam(data,(res) => {
      if (res != null) {
          if (res.headers["jtitoken"] != null) {
          localStorage.setItem("jti-token", res.headers.jtitoken);
          }
          fn(res.data);
      }
      }
  );
}
